<div class="mb-3">
  <!-- <ngx-file-drop dropZoneLabel="Drop files here" (onFileDrop)="dropped($event);uploadFilesPreview()" accept="{{fileAcceptedFormat}}" [useDragEnter]="true">
    <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector" >
      <div class="d-flex d-xl-none py-2 gap-2 align-items-center" (click)="openFileSelector()">
        <i class="bi bi-upload me-2"></i>
        <svg-icon name="upload-file" class="svg-32 svg-primary"></svg-icon><span class="text-secondary fw-500">Upload Files Here</span>
      </div>
      <div class="align-items-center d-none d-xl-flex flex-fill gap-3 justify-content-center dragfiles" role="button" (click)="openFileSelector()">
        <div class="w-75 d-flex align-items-center gap-2 justify-content-center">
          <svg-icon name="upload-file"></svg-icon>
          <div class="d-flex flex-column">
              <span class="fs-14 text-gray-300 fw-500">Drag and Drop to</span>
              <span class="fs-20 text-dark fw-500">Upload Files</span>
              <span class="fs-14 text-gray-300 fw-500">{{fileAcceptedFormat}}</span>
          </div>
        </div>
      </div>
    </ng-template>
  </ngx-file-drop> -->
  <app-file-drop (onFileDrop)="dropped($event); uploadFilesPreview()"></app-file-drop>

  <ng-template #uploadModal let-modal>
    <!-- <form class="needs-validation h-100" novalidate [formGroup]="manageFoldersForm" (ngSubmit)="submit()" #manageFoldersFormRef="ngForm" autocomplete="off"></form> -->
    <div class="modal-header">
      <h1 class="modal-title">Upload Files</h1>
      <span (click)="modal.dismiss('Cross click')" role="button">
        <svg-icon [name]="'modal-close-menu'" class="svg-32"></svg-icon>
      </span>
    </div>
    <div class="modal-body">
      <div class="mb-3">
        <!-- <ngx-file-drop dropZoneLabel="Drop files here"  (onFileDrop)="dropped($event);" accept="{{fileAcceptedFormat}}" [useDragEnter]="true">
    <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector" >
      <div class="align-items-center d-flex flex-fill gap-3 justify-content-center dragfiles" role="button" (click)="openFileSelector()">
        <svg-icon name="upload-file"></svg-icon>
        <div class="d-flex flex-column">
            <span class="fs-14 text-gray-300 fw-500">Drag and Drop to</span>
            <span class="fs-20 text-dark fw-500">Upload More Files</span>
            <span class="fs-14 text-gray-300 fw-500">{{fileAcceptedFormat}}</span>
        </div>
      </div>
    </ng-template>
  </ngx-file-drop> -->
        <app-file-drop (onFileDrop)="dropped($event)"></app-file-drop>
      </div>
      @if (this.isShowDuplicateMessage) {
        <div class="card-folder border p-3 rounded-3 alert alert-warning mb-4">
          <p>
            There are one or more files are duplicated. Do you want to replace the existing file with a new version or
            keep both files? Replacing the file won't change sharing settings.
          </p>
          <div class="bg-white p-2 rounded-3 d-inline-block position-relative">
            <div class="form-check form-check-inline cursor-pointer" role="button">
              <input
                class="form-check-input"
                type="radio"
                name="fileDuplicationCheck"
                [checked]="!replaceExisting"
                value=""
                id="keepBothFiles"
                (click)="replaceExisting = false"
              />
              <label class="form-check-label stretched-link" for="keepBothFiles"> Keep both files </label>
            </div>
          </div>
          <div class="bg-white p-2 rounded-3 d-inline-block ms-3 position-relative">
            <div class="form-check form-check-inline cursor-pointer" role="button">
              <input
                class="form-check-input"
                type="radio"
                name="fileDuplicationCheck"
                value=""
                id="replaceExistingFile"
                [checked]="replaceExisting"
                (click)="replaceExisting = true"
              />
              <label class="form-check-label stretched-link" for="replaceExistingFile"> Replace existing File </label>
            </div>
          </div>
        </div>
      }

      @if (attachedFiles.length > 0) {
        <div class="uploaded_files">
          <div class="d-flex flex-column gap-3">
            @for (item of attachedFiles; track $index) {
              <div>
                <div class="position-relative">
                  <!-- File Loader if file is in pending state -->

                  <!-- @if (!item.isUploadStarted) {
                  <div class="file_loader_outer rounded-3">
                    <div class="file_loader position-absolute z-4"></div>
                  </div>
                } -->

                  <!-- --uploading-percentage: 50% -->
                  <div
                    class="card card-folder rounded-4 border p-3 uploading --uploading-percentage upload_file"
                    [ngClass]="isUploadSubmitted && item.note == '' ? 'border-danger' : ''"
                    style="--uploading-percentage: {{ item.progress }}%;"
                    [style.--file-progress]="backgroundColor(item.progress)"
                  >
                    <div class="d-flex gap-2 mb-1">
                      @if (item) {
                        <svg-icon name="ft-{{ getFileExtension(item) }}" class="svg-32 ms-n2 mt-n1"></svg-icon>
                      } @else {
                        <svg-icon name="file"></svg-icon>
                      }

                      <div class="d-flex flex-column flex-fill overflow-hidden">
                        <span class="d-block fs-14 fw-600 text-truncate">{{ item.name }}</span>
                        @if (item.relativePath !== item.name) {
                          <span class="d-block fs-14 text-truncate" [ngbTooltip]="item.relativePath" placement="top">{{
                            item.relativePath
                          }}</span>
                        }
                        <span class="align-items-center d-flex fs-12 gap-2 text-nowrap"
                          >{{ fileSize(item.size) }}
                          @if (item.isUploadStarted) {
                            <span class="upload_percent d-inline-block"></span>
                          }
                          @if (item.progress !== 100 && item.isUploadStarted) {
                            <span class="fs-12 text-success">{{ item.progress }}%</span>
                          }
                          @if (item.progress === 100) {
                            <svg-icon name="tick-circle" class="svg-16"></svg-icon>
                          }
                        </span>
                      </div>
                      <span role="button" class="d-flex justify-content-between align-items-start gap-2 ms-1">
                        @if (item.isDuplicated) {
                          <span
                            class="bi bi-exclamation-triangle-fill fs-20 text-warning"
                            placement="top-right"
                            [ngbPopover]="duplicatedFile"
                            triggers="mouseenter:mouseleave"
                          ></span>
                          <ng-template #duplicatedFile>
                            <h6 class="mb-0">
                              <i class="bi bi-exclamation-triangle-fill fs-20 text-warning me-2"></i>Duplicated File
                            </h6>
                          </ng-template>
                        }

                        <svg-icon
                          name="delete"
                          class="svg-dark svg-20 text-danger"
                          (click)="!item.isUploadStarted ? removeFile($index) : null"
                        ></svg-icon>
                        <!-- @if (item.progress !== 100 && item.isUploadStarted) {
                          <span class="fs-14 fw-600 text-success">{{item.progress}}%</span>
                        }


                        @if (item.progress === 100) {
                          <svg-icon name="tick-circle" class="svg-24 text-success"></svg-icon>
                        } -->
                      </span>
                    </div>
                    <textarea
                      placeholder="Write notes here..."
                      [(ngModel)]="item.note"
                      rows="1"
                      class="form-control fs-16 mt-1"
                      [ngClass]="isUploadSubmitted && item.note == '' ? 'is-invalid' : ''"
                    ></textarea>
                    @if (isUploadSubmitted && item.note == '') {
                      <div class="py-0 mt-1 fs-12 text-danger">Notes are mandatory</div>
                    }
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      }
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-shadow" (click)="modal.close()">Cancel</button>
      @if (attachedFiles.length > 0) {
        <button type="button" class="btn btn-primary" (click)="uploadFiles()">Upload</button>
      }
    </div>
    <!-- </form> -->
  </ng-template>
</div>
